import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { Loading } from 'task-eva-ui/components/loading'
import { AuthGuard } from './route-guard'
import { Layout } from '@/components/layout/layout'
import { ErrorPageWrapper } from '@/components/error-boundary/ErrorBoundary'

const Output = lazy(() => import('@/pages/output'))

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthGuard>
          <Layout />
        </AuthGuard>
      </Suspense>
    ),
    errorElement: <ErrorPageWrapper />,
    children: [
      {
        path: 'output/:shareKey',
        element: <Output />,
      },
    ],
  },
])
